var map = {
	"./bg-pattern-desktop.svg": 87,
	"./bg-pattern-mobile.svg": 88,
	"./bg1.svg": 89,
	"./bg2.svg": 90,
	"./bg3.svg": 91,
	"./bg4.svg": 92,
	"./bg5.svg": 93,
	"./bg6.svg": 94,
	"./cta-illustration.svg": 95,
	"./favicon-32x32.png": 96,
	"./feature-tile-icon-01.svg": 41,
	"./feature-tile-icon-02.svg": 42,
	"./feature-tile-icon-03.svg": 43,
	"./feature-tile-icon-04.svg": 44,
	"./feature-tile-icon-05.svg": 45,
	"./feature-tile-icon-06.svg": 46,
	"./feature-tile-icon-07.svg": 25,
	"./feature-tile-icon-08.svg": 26,
	"./feature-tile-icon-09.svg": 27,
	"./feature-tile-icon-10.svg": 97,
	"./feature-tile-icon-11.svg": 98,
	"./feature-tile-icon-12.svg": 99,
	"./feature-tile-icon-13.svg": 100,
	"./feature-tile-icon-14.svg": 101,
	"./feature-tile-icon-15.svg": 28,
	"./feature-tile-icon-16.svg": 102,
	"./feature-tile-icon-17.svg": 29,
	"./feature-tile-icon-18.svg": 103,
	"./feature-tile-icon-19.svg": 30,
	"./features-split-image-01.png": 104,
	"./features-split-image-02.png": 105,
	"./features-split-image-03.png": 106,
	"./icon-arrow-down.svg": 107,
	"./illustration-box-desktop.svg": 108,
	"./illustration-section-01.svg": 109,
	"./illustration-section-02.svg": 110,
	"./illustration-woman-online-desktop.svg": 111,
	"./illustration-woman-online-mobile.svg": 112,
	"./logo.svg": 113,
	"./logo2.svg": 39,
	"./pl-csharp.png": 114,
	"./pl-java.png": 115,
	"./pl-javascript.png": 116,
	"./pl-netframe.png": 117,
	"./pl-rails.png": 118,
	"./pl-react.png": 119,
	"./pl-redux.png": 120,
	"./pl-ruby.png": 121,
	"./pl-soft-commu.png": 122,
	"./pl-soft-person.png": 123,
	"./pl-soft-skills.png": 124,
	"./pl-windows.png": 125,
	"./pl-writting.png": 126,
	"./portfolio1.png": 47,
	"./portfolio2.png": 48,
	"./portfolio3.png": 49,
	"./portfolio4.png": 50,
	"./portfolio5.png": 51,
	"./portfolio6.png": 52,
	"./portfolio7.png": 53,
	"./portfolio8.png": 54,
	"./portfolio9.png": 55,
	"./video-placeholder.jpg": 127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;